module.exports = __webpack_public_path__ + "static/media/ic_categories_fashion.3d12896b.svg";